import React from 'react'
import ReactDOM from 'react-dom/client' // Use react-dom/client instead of react-dom
import './index.css'
import * as serviceWorker from './serviceWorker'
import App from './App'

// Get the root element
const rootElement = document.getElementById('root')

// Create the root and render the app
const root = ReactDOM.createRoot(rootElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Service worker setup (optional)
serviceWorker.unregister()
